<a href="" [routerLink]="'/case-studies/'+caseStudy.id" (click)="navigateToCaseStudy()">
    <div class="img-card" [bgImage]="caseStudy.imageThumbnailSrc" [overlayColor]="caseStudy.imageOverlayColor">
        <div class="img-card-content">
            <h2 class="img-card-title">
                {{ caseStudy.title }}
            </h2>
            <div class="img-card-read-more">Read more</div>
        </div>
    </div>
</a>